import { sendSumoLog } from './sumoLogger';
import { fetchTicketDocs } from './fetchTicketDocs';

export const fetchArchiveDocuments = async (id, token, dispatch) => {
  try {
    let data = await fetchTicketDocs(id, token, dispatch, true);
    let resultsArray = [];
    let rows = data.rows || (data.results && data.results.rows);
    if (rows) {
      while (data && rows.length === 1000) {
        resultsArray = [...resultsArray, ...rows];
        const next1000 = await fetchTicketDocs(
          id,
          token,
          dispatch,
          true,
          data.last_seq
        );
        data = await next1000;
        rows = data.rows || (data.results && data.results.rows);
      }
      resultsArray = [...resultsArray, ...rows];
    }
    return {
      resultsArray: resultsArray,
      lastSequence: data.last_seq,
    };
  } catch (errorCode) {
    const errorType = 'fetchDocumentID';
    const message = `fetch documents ${id} failed`;
    sendSumoLog(errorType, message, errorCode, dispatch);
    return {
      resultsArray: [],
    };
  }
};
